import React, { Fragment, useEffect, useState } from 'react';
import {
  EditItem,
  LoadingContainer,
  PageContainer,
} from '../../components/Layout';
import i18n from '@/utils/i18n';
import AddContainerQrRedirectionCampaignForm from './AddContainerQrRedirectionCampaignForm';
import { useGetContainerQrRedirectionCampaignsQuery } from '../../graphql/queries/getContainerQrRedirectionCampaigns.generated';
import ContainerQrRedirectionCampaignRow from './ContainerQrRedirectionCampaignRow';
import { Communicator } from '../../tools/Communication';
import { ContainerType } from '../Events/OrderFulfillment/Components/OrderFulfillmentAddContainerTypes';
import { ContentSection } from '../../components/Layout/ContentSection';
import { Table, Button, ButtonGroup } from 'reactstrap';

type ViewType = 'active' | 'expired';

const ContainerQrRedirectionCampaignView = () => {
  const [refresh, setRefresh] = useState(false);
  const [containerTypes, setContainerTypes] = useState<ContainerType[]>([]);
  const [currentView, setCurrentView] = useState<ViewType>('active');

  const {
    data,
    loading,
    error,
    refetch: refretchContainerQrRedirectionCampaigns,
  } = useGetContainerQrRedirectionCampaignsQuery();

  useEffect(() => {
    Communicator.Get('api/3/containers/getAllContainerTypes', {})
      .then((response) => response.json())
      .then((data) => {
        setContainerTypes(data);
      });
  }, []);

  useEffect(() => {
    if (refresh) {
      refretchContainerQrRedirectionCampaigns();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (error) {
      console.log(error, error?.message);
    }
  }, [error]);

  const containerQrRedirectionCampaigns = data?.containerQrRedirectionCampaigns;

  const filteredCampaigns = containerQrRedirectionCampaigns?.filter(
    (campaign) => {
      if (!campaign || !campaign.end_date) return false;

      const now = new Date();
      const endDate = new Date(campaign.end_date);
      const isActive = endDate >= now;

      return currentView === 'active' ? isActive : !isActive;
    },
  );

  const isTableEmpty = filteredCampaigns?.length === 0;

  return (
    <>
      <PageContainer>
        <ContentSection
          title={i18n.t('ContainerQrRedirectionCampaign:title')}
          collapsable={false}
        >
          <EditItem title={i18n.t('ContainerQrRedirectionCampaign:addSection')}>
            <AddContainerQrRedirectionCampaignForm
              containerTypes={containerTypes}
              setRefresh={setRefresh}
            />
          </EditItem>
          <EditItem
            title={i18n.t('ContainerQrRedirectionCampaign:tableSection')}
          >
            <div className="mb-3">
              <ButtonGroup>
                <Button
                  color={currentView === 'active' ? 'primary' : 'secondary'}
                  onClick={() => setCurrentView('active')}
                  active={currentView === 'active'}
                >
                  {i18n.t('ContainerQrRedirectionCampaign:activeCampaigns')}
                </Button>
                <Button
                  color={currentView === 'expired' ? 'primary' : 'secondary'}
                  onClick={() => setCurrentView('expired')}
                  active={currentView === 'expired'}
                >
                  {i18n.t('ContainerQrRedirectionCampaign:expiredCampaigns')}
                </Button>
              </ButtonGroup>
            </div>

            {loading && <LoadingContainer />}

            {!loading && (
              <Table striped hover bordered responsive>
                <thead>
                  <tr>
                    <th>
                      {i18n.t('ContainerQrRedirectionCampaign:containerType')}
                    </th>
                    <th>
                      {i18n.t('ContainerQrRedirectionCampaign:redirectUrl')}
                    </th>
                    <th>
                      {i18n.t('ContainerQrRedirectionCampaign:startDate')}↓
                    </th>
                    <th>{i18n.t('ContainerQrRedirectionCampaign:endDate')}</th>
                    <th>
                      {i18n.t('ContainerQrRedirectionCampaign:visitCount')}
                    </th>
                    <th>{i18n.t('ContainerQrRedirectionCampaign:comment')}</th>
                    <th>
                      {i18n.t(
                        'ContainerQrRedirectionCampaign:forwardContainerShortId',
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {isTableEmpty && (
                    <tr>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                      <td className="align-middle">-</td>
                    </tr>
                  )}
                  {filteredCampaigns &&
                    filteredCampaigns.map((containerQrRedirect) => {
                      if (!containerQrRedirect) {
                        return null;
                      }

                      return (
                        <Fragment key={containerQrRedirect.id}>
                          <ContainerQrRedirectionCampaignRow
                            containerTypes={containerTypes}
                            containerQrRedirect={containerQrRedirect}
                            setRefresh={setRefresh}
                          />
                        </Fragment>
                      );
                    })}
                </tbody>
              </Table>
            )}
          </EditItem>
        </ContentSection>
      </PageContainer>
    </>
  );
};

export default ContainerQrRedirectionCampaignView;
